// extracted by mini-css-extract-plugin
export var avatar = "_p3-3";
export var avatarContainer = "_p3-2";
export var avatarSpacer = "_p3-5";
export var avatarSpacerContainer = "_p3-4";
export var avatarStackContainer = "_p3-1";
export var bubble = "_p3-0";
export var remainderBubble = "_p3-6";